export var DRAWER_WIDTH_COLLAPSED = 70;
export var DRAWER_WIDTH_EXPANDED = 224;
